import GraphQLPropertyDAOFactory from "../../../../lib/property/dao/graphql/GraphQLPropertyDAOFactory";
import { useQuery } from "react-query";

const propertyDAO = GraphQLPropertyDAOFactory.getInstance();

export const useProperty = (propertyId: string) => {
    const getPropertyQueryResult = useQuery({
        queryKey: ["property", propertyId],
        queryFn: async () => {
            return propertyDAO.getById(propertyId);
        }
    });
    return getPropertyQueryResult;
};